/** @format */

import React from 'react';
import '../css/Header.css';

import zbrush from '../images/technologies/zbrush.png';
import substance from '../images/technologies/substance.png';
import avatarTeacher from '../images/logo_dot.png';
import Tags from './buttons/Tags';
import dayjs from 'dayjs';
import Countdown from './Countdown';

import { useDispatch, useSelector } from 'react-redux';

import { openCounseling } from '../features/counseling';
import { openVideo } from '../features/video';

import BulletPointBlink from './buttons/BulletPointBlink';
import BulletPoint from './buttons/BulletPoint';

import Image from 'react-image-webp';

import image from '../images/3d-isolated.png';
import imageWebp from '../images/3d-isolated.webp';

import backgroundRight from '../images/2-resize.jpg';
import backgroundRightWebp from '../images/2-resize.webp';

import backgroundLeftResize from '../images/1-resize.jpg';
import backgroundLeftWebpResize from '../images/1-resize.webp';

import underline from '../images/underline.png';

const countdown = 'Sat, 5 Nov 2022 15:00:00 GMT-5';

const benefits = [
	// 'Clases online en vivo.',
	'Material de ayuda.',
	'Grabaremos las clases.',
	'Acceso Discord.',
	'Certificado.',
	'Acceso 1 año.',
];

const Header = () => {
	const nowDay = dayjs();
	const openingDay = dayjs(countdown);

	const dispatch = useDispatch();

	const handleLink = (e) => {
		e.preventDefault();
		const target = e.target.getAttribute('href');
		const location = document.querySelector(target).offsetTop;
		window.scrollTo({
			left: 0,
			top: location - 80,
		});
	};

	const banner = useSelector((state) => state.banner.value.banner);
	const width = window.innerWidth <= 460 ? 20 : 20;

	const paddingTop = banner ? { paddingTop: width + 80 } : { paddingTop: 80 };

	return (
		<section className='Header' id='home' style={paddingTop}>
			<div className='header-background'>
				<div className='left'>
					<Image
						src={backgroundLeftResize}
						webp={backgroundLeftWebpResize}
						alt='background'
						style={{
							height: '100%',
							width: '100%',
							objectFit: 'cover',
							position: 'relative',
							left: '-10%',
						}}
					/>
				</div>
				<div className='right'>
					<Image
						src={backgroundRight}
						webp={backgroundRightWebp}
						alt='background'
						style={{
							height: '100%',
							width: '100%',
							objectFit: 'cover',
						}}
					/>
				</div>
			</div>
			<div className='header-filter'></div>
			<div className='header-container container '>
				<div className='header-content padding'>
					<Image src={image} webp={imageWebp} alt='Máster en Blender' className='header-image' />
					<div className='header-item'>
						<BulletPoint color={'#77bf41'} />
						<p>Feedback en vivo</p>
					</div>
					<h1 className='header-title'>
						ESCUELA
						<br />
						<span>
							ZBRUSH
							<img src={underline} alt='underline' className='underline' />
						</span>
					</h1>
					<div className='header-buttons'>
						<button
							className='header-button see-trailer'
							onClick={() => {
								dispatch(
									openVideo({
										modal: true,
										url: 'https://www.youtube.com/watch?v=RnFm-puWjYU',
										type: 'common',
									})
								);
							}}
						>
							VER TRAILER
						</button>

						<a
							href='https://www.dropbox.com/s/vx2r8tr1st3bnww/Theme_ZBrush_01.pdf?dl=0'
							target='_blank'
							rel='noreferrer'
							className='header-button see-payment'
							// onClick={handleLink}
						>
							VER TEMÁTICA
						</a>
					</div>
					<div className='master-benefits'>
						{benefits.map((benefit, index) => (
							<div key={index} className='header-item' style={{ fontWeight: 'normal' }}>
								<BulletPoint color={'#6000de'} />
								<p>{benefit}</p>
							</div>
						))}
					</div>
				</div>
				<div className='header-information'>
					<div className='header-information-content'>
						<img src={avatarTeacher} alt='Avatar Teacher' />
						<p className='teacher'>
							<span>Profesor: </span>Martin Sanchez
						</p>
						<h2>
							Agenda tu
							<br />
							asesoría gratis
						</h2>
						<Tags name={'SOLICITA ASESORÍA'} />
						{openingDay.isAfter(nowDay) ? (
							<Countdown countdownTimestampMs={countdown} />
						) : (
							<h3 className='start-master'>
								<BulletPointBlink color={'#77bf41'} />
								<span>Ya inició</span>
							</h3>
						)}
						<a href='#entrenamientos' className='payment' onClick={handleLink}>
							Únete <span>&nbsp;Ahora</span>
						</a>
						<a href='#metodos-de-pago' className='to-payment-methods' onClick={handleLink}>
							MÉTODOS DE PAGO
						</a>
						<button
							className='payment-information'
							onClick={() => {
								dispatch(openCounseling());
							}}
						>
							* Pregunta por nuestros planes
							<br /> de financiación.
						</button>
					</div>
					<div className='header-information-technologies'>
						<img
							src={zbrush}
							alt='technology'
							style={{ width: 30, height: 30, objectFit: 'contain' }}
						/>
						<img
							src={substance}
							alt='technology'
							style={{ width: 30, height: 30, objectFit: 'contain' }}
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Header;
